import { useLoaderData } from "@remix-run/react";
import SideBar from "~/components/SideBar";
import type { AuthenticatedUser } from "~/models/auth";

interface RouteWrapperWithSidebarProps {
  children: React.ReactNode;
  user?: AuthenticatedUser | null;
}

export default function RouteWrapperWithSidebar({ 
  children, 
  user 
}: RouteWrapperWithSidebarProps) {
  return (
    <SideBar user={user || null}>
      {children}
    </SideBar>
  );
}
